export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-ease/src/linear.js
// module id = ../../../../d3-ease/src/linear.js
// module chunks = 4